module.exports = __webpack_public_path__ + "static/media/cornwall3.19705249.jpg";